<template>
  <div class="goods_index">
    <el-breadcrumb separator="/" slot="breadcrumb" class="breadcrumb-bg">
      <el-breadcrumb-item :to="{ path: '/admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'agent_index' }">我的采购单</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="header-top-15">
      <el-card class="box-card">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="订单号">
            <el-input v-model="order_id" placeholder="订单号" @input="order_search"></el-input>
          </el-form-item>

          <el-form-item>
              <el-button type="primary" @click="order_status('')">所有订单</el-button>
            <el-button type="primary" @click="order_status(1)">已付款订单</el-button>
              <el-button type="primary" @click="order_status(0)">未付款订单</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <el-table
      :data="tableData.data"
      stripe
      style="width: 100%; margin-top: 10px"
      @selection-change="handleSelectionChange"
      ref="multipleTable"
    >
      <el-table-column prop="id" label="ID" type="selection"> </el-table-column>
      <el-table-column prop="oid" label="订单号"> </el-table-column>
      <el-table-column prop="agent_user.username" label="用户" width="180">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :content="scope.row.agent_user.username"
            placement="top-start"
          >
            <span>{{ scope.row.agent_user.username }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="level" label="创建日期">
        <template slot-scope="scope">
          {{ formatGMT(scope.row.created_time) }}
        </template>
      </el-table-column>

      <el-table-column prop="totalprice" label="采购价">
        <template slot-scope="scope">
          {{ scope.row.totalprice }}
        </template>
      </el-table-column>

      <el-table-column prop="agent" label="状态">
        <template slot-scope="scope">
            <span v-if="scope.row.status==0">未付款</span>
            <span v-if="scope.row.status==1">已付款</span>

        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="7">
              <el-button size="mini" @click="orderDetail(scope.row)">查看</el-button>
            </el-col>
            <!--
            <el-col :span="7">
              <el-button size="mini">删除</el-button>
            </el-col>
            -->
            <el-col :span="7">
              <!-- <el-button size="mini" @click="salesService(scope.row)">售后</el-button> -->
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <div class="header-top-15">
      <el-card class="box-card">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableData.totalpages"
          @current-change="changePage"
        >
        </el-pagination>
      </el-card>
    </div>

    <!-- <el-dialog title="售后服务" :visible.sync="dialogFormVisible">
      <div class="title1">订单号:{{ form.oid }}</div>
      <el-form :model="form">
        <el-form-item label="问题">
          <el-select v-model="form.issue" placeholder="请选择活动区域">
            <el-option label="退货" value="退货"></el-option>
            <el-option label="缺货" value="缺货"></el-option>
            <el-option label="缺货" value="其他问题"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="form.describe" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click.native="addSalesService()">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      formInline: {
        oid: "",
      },
      order_id:"",
      form: {
        issue: "",
        describe: "",
        oid: "",
      },
      status:"",
      multipleSelection: [],
      dialogFormVisible: false,
      dialogStoreVisible: false,
      agent: false,
      product_stock: {},
      dialog_msg_visible: false,
      dialog_restore_visible: false,
      page: 1,
    };
  },
  methods: {
    ...mapActions({
      getorderAllDataAction: "getorderAllDataAction",
      addOrderServiceAction: "addOrderServiceAction",
    }),
    formatGMT(gmt, long) {
      long = false === long ? false : true;
      let date = new Date(gmt);

      let m = date.getMonth() + 1,
        mm = "-" + (m < 10 ? "0" + m : m);
      let d = date.getDate(),
        dd = "-" + (d < 10 ? "0" + d : d);
      let h = date.getHours(),
        hh = " " + (h < 10 ? "0" + h : h);
      let i = date.getMinutes(),
        ii = ":" + (i < 10 ? "0" + i : i);
      let s = date.getSeconds(),
        ss = ":" + (s < 10 ? "0" + s : s);

      return date.getFullYear() + mm + dd + (long ? hh + ii + ss : "");
    },
    //售后服务
    salesService(row) {
      console.log(row);
      this.dialogFormVisible = true;

      this.form.oid = row.oid;
    },
    //添加售后服务
    addSalesService() {
      let order = {
        oid: this.form.oid,
        describe: this.form.describe,
        issue: this.form.issue,
      };
      this.addOrderServiceAction(order);
      this.dialogFormVisible = false;
    },
    order_status(e){
        this.page = 1;
        this.status=e
        this.getorderAllDataAction({ page: this.page,"payment":this.status,"order_id":this.order_id});
    },
    order_search() {
        this.page = 1;
        this.getorderAllDataAction({ page: this.page,"payment":this.status,"order_id":this.order_id});
          // this.changePageData(e);
      },
    orderDetail(row) {
      const id = row.id;

      this.$router.push({
        name: "order_detail",
        params: {
          id: id,
        },
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    changePage(e) {
      this.page = e;
      this.changePageData(e);
    },
    changePageData(page) {
      this.page = page;
      console.log("tag", this.page);
      this.getorderAllDataAction({ page: page,"payment":this.status,"order_id":this.order_id});
    },
  },
  created() {
    this.getorderAllDataAction({ page: this.page,"payment":this.status,"order_id":this.order_id });
  },
  //tableData
  computed: mapState({
    tableData: (state) => state.order.result,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
